export function fixedNumber(value, decimalPoint) {
  const roundValue =
    Math.round(Number(value) * Math.pow(10, decimalPoint)) / Math.pow(10, decimalPoint)
  return roundValue.toFixed(decimalPoint)
}

export function commify(s) {
  return s
    .toString()
    .split('')
    .reverse()
    .join('')
    .replace(/(\d\d\d)(?=\d)(?!\d*\.)/g, '$1,')
    .split('')
    .reverse()
    .join('')
}

export const units = {
  trillionYen: {
    str: '兆円',
    value: 1000000000000,
  },
  hundredMillionYen: {
    str: '億円',
    value: 100000000,
  },
  tenThousandYen: {
    str: '万円',
    value: 10000,
  },
  yen: {
    str: '円',
    value: 1,
  },
}

export function xorUndefined(a, b) {
  return (a !== undefined && b === undefined) || (a === undefined && b !== undefined)
}

export function validateIsNumber(value) {
  return value.match(/^[+-]?[0-9]+\.?[0-9]*$/) !== null && !isNaN(parseFloat(value))
}

export function getDecimalPointLength(value) {
  if (isNaN(Number(value))) {
    return NaN
  }
  const numberParts = value.split('.')
  return numberParts[1] ? numberParts[1].length : 0
}

export function propertiesIsNaN(obj) {
  if (obj === undefined) return true
  if (obj === null) return false
  for (const [, value] of Object.entries(obj)) {
    switch (Array.isArray(value)) {
      case false:
        if (isNaN(value)) return true
        break
      case true:
        if (value.some(isNaN)) return true
        break
      default:
    }
  }
  return false
}
